import React from 'react'

const Paymentservice = () => {
  return (
    <div className='container'>
        <div className='text-xl'><strong>Payment Services</strong></div>
        <div className='mt-4'>
      At the moment, Campusify does not offer any payment services. However, we partner with logistics companies to provide payment services to our customers.In doing so, we offer third party payment service.<strong> Please contact any of the following hotlines to request for payment: 08164910957, 09068412463</strong>
        </div>
    </div>
  )
}

export default Paymentservice